module.exports = KsysAppTemplateV4dot0dot0;